module.exports = __webpack_public_path__ + "static/media/crack.d5cabb14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/crack.jpg
// module id = 294
// module chunks = 0